import React from "react";
import { Link } from "react-router-dom";
import { GlassWater, Heart, Gift, Sparkles, Building, Briefcase, CalendarCheck, ArrowRight } from "lucide-react";

export default function Services() {
  const servicesList = [
    {
      title: "Nunți",
      slug: "nunti",
      description: "Nunta visurilor tale prinde viață într-un cadru spectaculos, cu un design opulent și meniuri fine gourmet.",
      icon: <Heart strokeWidth={1.2} size={32} />
    },
    {
      title: "Botezuri",
      slug: "botezuri",
      description: "Sărbătorește sosirea pe lume a micuțului tău într-o atmosferă caldă, plină de eleganță și decoruri feerice.",
      icon: <Sparkles strokeWidth={1.2} size={32} />
    },
    {
      title: "Cununii",
      slug: "cununii",
      description: "Ceremonii de cununie în aer liber sau în sală, create cu atenție maximă la detalii și o atmosferă feerică.",
      icon: <CalendarCheck strokeWidth={1.2} size={32} />
    },
    {
      title: "Aniversări",
      slug: "aniversari",
      description: "Petreceri aniversare memorabile, cu decoruri personalizate și servicii impecabile pentru toți invitații tăi.",
      icon: <Gift strokeWidth={1.2} size={32} />
    },
    {
      title: "Petreceri Private",
      slug: "petreceri-private",
      description: "Evenimente exclusiviste, majorate sau banchete, adaptate în totalitate cerințelor și stilului tău personal.",
      icon: <GlassWater strokeWidth={1.2} size={32} />
    },
    {
      title: "Evenimente Corporate",
      slug: "evenimente-corporate",
      description: "Conferințe, gale, lansări de produse și team-building-uri la cel mai înalt nivel profesional în Sibiu.",
      icon: <Building strokeWidth={1.2} size={32} />
    },
    {
      title: "Organizare Personalizată",
      slug: null,
      description: "Serviciu complet de wedding & event planning pentru a te asigura că te bucuri pe deplin de ziua ta specială.",
      icon: <Briefcase strokeWidth={1.2} size={32} />
    }
  ];

  return (
    <section 
      id="servicii"
      data-testid="services-section"
      className="py-24 sm:py-32 bg-[#0A0A0A] relative"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Header Section */}
        <div className="text-center space-y-4 mb-20">
          <span className="text-xs font-semibold tracking-[0.3em] text-[#D4AF37] uppercase">
            SERVICII DE EXCEPȚIE
          </span>
          <h2 
            data-testid="services-title"
            className="font-serif-lux text-3xl sm:text-5xl text-white font-medium tracking-tight"
          >
            Serviciile Noastre Exclusive
          </h2>
          <div className="w-24 h-[1px] bg-[#D4AF37]/50 mx-auto mt-4" />
          <p className="text-sm sm:text-base text-[#F3E5D8] max-w-2xl mx-auto font-light">
            Oferim servicii integrate pentru organizarea impecabilă a oricărui tip de eveniment, îmbinând rafinamentul estetic cu precizia tehnică.
          </p>
        </div>

        {/* Bento/Grid style for services */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {servicesList.map((service, i) => (
            <div
              key={i}
              data-testid={`service-card-${service.title.toLowerCase().replace(/\s+/g, "-")}`}
              className="group p-8 bg-[#121212] border border-[#D4AF37]/10 hover:border-[#D4AF37]/50 transition-all duration-300 transform hover:-translate-y-1 relative overflow-hidden"
            >
              {/* Card Corner accent */}
              <div className="absolute top-0 right-0 w-8 h-8 bg-gradient-to-br from-[#D4AF37]/10 to-transparent transform rotate-45" />

              <div className="text-[#D4AF37] mb-6 transform group-hover:scale-110 transition-transform duration-300 inline-block">
                {service.icon}
              </div>

              <h3 className="font-serif-lux text-xl sm:text-2xl text-white font-medium mb-3">
                {service.title}
              </h3>

              <p className="text-sm text-white/60 leading-relaxed font-light">
                {service.description}
              </p>

              {service.slug && (
                <Link
                  to={`/${service.slug}`}
                  data-testid={`service-learn-more-${service.slug}`}
                  className="mt-5 inline-flex items-center gap-1.5 text-[#D4AF37] hover:text-white text-xs font-semibold uppercase tracking-widest transition-colors"
                >
                  Află mai multe <ArrowRight size={13} />
                </Link>
              )}
            </div>
          ))}
        </div>

        {/* Call to Action Inside Services */}
        <div className="text-center mt-16">
          <button
            data-testid="services-view-gallery-btn"
            onClick={() => {
              const element = document.getElementById("galerie");
              if (element) element.scrollIntoView({ behavior: "smooth" });
            }}
            className="border-b border-[#D4AF37] text-[#D4AF37] hover:text-white hover:border-white transition-colors pb-1 text-sm tracking-widest uppercase font-semibold"
          >
            Vizualizează Galerie Foto
          </button>
        </div>
      </div>
    </section>
  );
}
